<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-btn fab large fixed bottom right color="primary" v-bind:to="{ name: 'New Fabric' }">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <h4>Fabrics <span v-if="fabrics">({{ fabrics.length }})</span></h4>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-data-table :headers="headers" :items="fabrics" :search="search" :loading="fabricsLoading">
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.group.name }}</td>
                <td>{{ props.item.group.type }}</td>
                <td v-if="props.item.category != null">{{ props.item.category.name }}</td>
                <td v-else></td>
                <td>
                    <router-link v-bind:to="{ name: 'Colours', params: { fabricID: props.item._id }}">Colours ({{ props.item.colorCount }})</router-link>
                    <router-link v-bind:to="{ name: 'Edit Fabric', params: { fabricID: props.item._id }}">Edit</router-link>
                    <a href="#">Toggle</a>
                    <button @click="deleteFabric(props.item._id)">Delete</button>
                </td>
              </template>
              <template slot="no-data">
                Loading...
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import FabricService from '@/services/FabricService.js'
export default {
  data () {
    return {
      fabrics: [],
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Group', value: 'type' },
        { text: 'Pricing Category', value: 'pricingCategory' },
        { text: 'Colours', value: 'colours' },
        { text: 'Actions', value: 'actions' }
      ],
      fabricsLoading: true,
      search: null
    }
  },
  mounted () {
    this.getFabrics()
  },
  methods: {
    async getFabrics () {
      const response = await FabricService.getFabrics()
      this.fabrics = response.data.fabrics
      this.fabricsLoading = false
    },

    async deleteFabric (fabricID) {
      await FabricService.deleteFabric(fabricID)
      this.getFabrics()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/fabrics/Fabrics.vue